/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section } from 'spectacle-ppa';

import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_opening.md';
import markdownFileLevel2 from './level2_opening.md';
import markdownFileLevel3 from './level3_opening.md';
import markdownFileLevel4 from './level4_opening.md';
import markdownFileLevel5 from './level5_opening.md';
import markdownFileLevel6 from './level6_opening.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) },
  '4': { md: new MarkdownScript(markdownFileLevel4) },
  '5': { md: new MarkdownScript(markdownFileLevel5) },
  '6': { md: new MarkdownScript(markdownFileLevel6) }
};

function esOpeningStory ({ level, regionData }) {
  const md = levels[level].md;
  return (
    <Section id={"opening"}>

      {/* Intro to Es Opening in Levels 1, 2 + 4 */}
      { (level === 1 || level === 2 || level === 4) &&
        videoSlide({
          id: 'intro-video',
          notes: md.getSubSectionAsHtml('Ian and Sara Intro', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Ian and Sara Intro', 'YouTube', regionData)
        })
      }

      {/* Framing Story Opening */}
      {videoSlide({
        id: 'story',
        notes: md.getSubSectionAsHtml('Esmeralda and Goober Opening Story', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Esmeralda and Goober Opening Story', 'YouTube', regionData)
      })}

      {/* Disposable Rap Intro in Level 4 */}
      { (level === 4) &&
        videoSlide({
          id: 'disposable-rap-intro',
          notes: md.getSubSectionAsHtml('Disposable Rap Intro', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Disposable Rap Intro', 'YouTube', regionData)
        })
      }

      {/* Disposable Rap in Level 4 */}
      { (level === 4) &&
        videoSlide({
          id: 'disposable-rap',
          notes: md.getSubSectionAsHtml('Disposable Rap', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Disposable Rap', 'YouTube', regionData)
        })
      }

      {/* Intro to Song of Stuff in Level 6 */}
      { (level === 6) &&
        videoSlide({
          id: 'song-of-stuff-intro',
          notes: md.getSubSectionAsHtml('Intro to Song of Stuff', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Intro to Song of Stuff', 'YouTube', regionData)        })
      }

      {/* Song of Stuff in Level 6 */}
      { (level === 6) &&
        videoSlide({
          id: 'e-waste',
          notes: md.getSubSectionAsHtml('Song of Stuff', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Song of Stuff', 'YouTube', regionData)        })
      }

    </Section>
  );
}


export default esOpeningStory;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/12_esOpeningStory/esOpeningStorySection.jsx